/**
 * IMPORT TYPES
 * @typedef {import('~/types/ShoppingCart').ShoppingCartStore} ShoppingCartStore
 * @typedef {import('~/types/ShoppingCart').PriceBreakdown} PriceBreakdown
 * @typedef {import('~/types/ShoppingCart').ProductsModel} ProductsModel
 * @typedef {import('~/types/ShoppingCart').MeetingRoomWidget} MeetingRoomWidget
 */

export const useShoppingCartStore = defineStore("shoppingCart", () => {
  const isLoading = ref();
  const shoppingCartId = ref();
  const status = ref();
  const shopper = ref();
  const company = ref();
  /**@type {import('vue').Ref<PriceBreakdown | undefined>} */
  const priceBreakdown = ref();
  /** @type {import('vue').Ref<ProductsModel | undefined> } */
  const products = ref();
  const hotelRoomOffers = ref();
  const meetingRoomOffers = ref();
  const subscriptionOffers = ref();
  const paymentSessions = ref();

  /** @type {import('vue').ComputedRef<ShoppingCartStore> } */
  const value = computed(() => {
    return {
      status: status.value,
      priceBreakdown: priceBreakdown.value,
      products: products.value,
      hotelRoomOffers: hotelRoomOffers.value,
      meetingRoomOffers: meetingRoomOffers.value,
      subscriptionOffers: subscriptionOffers.value,
      paymentSessions: paymentSessions.value,
    };
  });
  const rateInShoppingCartRequiresLogin = ref();
  const rateInShoppingCartRequiresSubscription = ref();

  function resetShoppingCart() {
    isLoading.value = undefined;
    shoppingCartId.value = undefined;
    status.value = undefined;
    shopper.value = undefined;
    priceBreakdown.value = undefined;
    products.value = undefined;
    hotelRoomOffers.value = undefined;
    meetingRoomOffers.value = undefined;
    paymentSessions.value = undefined;

    rateInShoppingCartRequiresLogin.value = undefined;
    rateInShoppingCartRequiresSubscription.value = undefined;

    document.cookie =
      "shoppingCartId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  function resetSubscriptionShoppingCart() {
    isLoading.value = undefined;
    shoppingCartId.value = undefined;
    status.value = undefined;
    shopper.value = undefined;
    priceBreakdown.value = undefined;
    products.value = undefined;
    hotelRoomOffers.value = undefined;
    paymentSessions.value = undefined;

    rateInShoppingCartRequiresLogin.value = undefined;
    rateInShoppingCartRequiresSubscription.value = undefined;

    document.cookie =
      "subscriptionShoppingCartId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  /**
   * Returns the shopping cart store as an object
   * @returns {ShoppingCartStore}
   */
  function getShoppingCartStoreObject() {
    return {
      status: status.value,
      priceBreakdown: priceBreakdown.value,
      products: products.value,
      hotelRoomOffers: hotelRoomOffers.value,
      meetingRoomOffers: meetingRoomOffers.value,
      subscriptionOffers: subscriptionOffers.value,
      paymentSessions: paymentSessions.value,
    };
  }

  return {
    value,
    isLoading,
    shoppingCartId,
    status,
    shopper,
    company,
    priceBreakdown,
    products,
    hotelRoomOffers,
    meetingRoomOffers,
    subscriptionOffers,
    paymentSessions,
    rateInShoppingCartRequiresLogin,
    rateInShoppingCartRequiresSubscription,
    resetShoppingCart,
    resetSubscriptionShoppingCart,
    getShoppingCartStoreObject,
  };
});
